<template>
  <lu-vbox lu-flex class='card-container sdetailView settingsTable vpad-in-5'>

      <PageTitle class='card-header' :title='title' :hasClose='true'  @togglePageTitle='detailToggleClose'>
        <lu-item slot='extraArea' lu-flex>
          <div>
            <el-tooltip class="item" :effect="styleTooltip" :content="formatToolTip(value)" placement="top" :disabled="disableToolTip(value)">
              <el-cascader
                placeholder="Book"
                v-model="value"
                :options="bookList"
                clearable :appendToBody="false" :filter-method="filterMethod" filterable v-if='showBookFilter' :show-all-levels="false" @change="detailChangeBookFilter" style="width: 120px;"></el-cascader>
            </el-tooltip>
          </div>
        </lu-item>

        <lu-item slot='extraArea' lu-flex v-if='paramType!=="flow"'>
          <el-switch v-model='lotsMios'
            active-value='mios' inactive-value='lots'
            :active-text='$t("Mio")' :inactive-text='$t("Lots")'
          />
        </lu-item>

        <el-tooltip slot='extraArea' class="item" :effect="styleTooltip" :content="$t('Export Excel')" placement="top">
          <lu-item class='el-icon-download' lu-click style='margin-right:5px;' @click.stop='onexportexcel'></lu-item>
        </el-tooltip>
      </PageTitle>

      <lu-hbox class='titleInfo'>
        <lu-hbox lu-hcenter lu-vcenter class='item pad-in-5' v-for="(item, idx) in data['titleInfo']" :key="idx">
          <lu-item class='title'>{{ $t(item.label) }} :</lu-item>
          <lu-item class='value' :class='item.val >= 0  ? "positive" : "negative"'>{{ item.value }}</lu-item>
        </lu-hbox>
        <!-- <el-divider direction="vertical"></el-divider> -->
      </lu-hbox>

      <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
        <lu-item style='padding: 0 10px'>
          <table width='100%' class='table'>
            <tr>
              <th class='colTitle' v-for="(header, index) in tableHeaders" :key="index">
                <div style="word-wrap: break-word; padding: 5px;">{{ $t(header) }}</div>
              </th>
            </tr>
            <!-- when making changes to column content please update tableFields, otherwise export tables will be broken  -->
            <tr class='lu-click' v-for="(item, idx) in data['detail']" :key='idx'>

              <td class='rowTitle tableCol' v-if='paramType !== "account"'>{{ item.brokerName }}</td>
              <td class='rowTitle tableCol'>{{ item.bookName }}</td>

              <template v-if='paramType === "symbol" || paramType === "flow"'>
                <td class='rowTitle tableCol' >
                  <span @dblclick='getDetail("account", item.brokerName, item.accountNumber, item.dosName)'>{{ item.dosName }}</span>
                </td>
                <td class='rowTitle tableCol' >
                  <span @dblclick='getDetail("account", item.brokerName, item.accountNumber, item.dosName)'>{{ item.accountNumber }}</span>
                </td>
              </template>
              <template v-else-if='paramType === "currency"'>
                <td class='rowTitle tableCol'>
                  <span @dblclick='getDetail("account", item.brokerName, item.accountNumber, item.dosName)'>{{ item.dosName }}</span>
                </td>
                <td class='rowTitle tableCol'>
                  <span @dblclick='getDetail("account", item.brokerName, item.accountNumber, item.dosName)'>{{ item.accountNumber }}</span>
                </td>
                <td class='rowTitle tableCol'>
                  <span @dblclick='getDetail("symbol", item.brokerName, item.accountNumber, item.instrumentName)'>{{ item.instrumentName }}</span>
                </td>
              </template>
              <template v-else-if='paramType === "account"'>
                <td class='rowTitle tableCol'>
                  <span @dblclick='getDetail("symbol", item.brokerName, item.accountNumber, item.instrumentName)'>{{ item.instrumentName }}</span>
                </td>
              </template>
              <td class='rowTitle tableCol' v-if='paramType === "symbol"'>{{ item.agent }}</td>
              <td class='rowTitle tableCol' v-if='paramType === "symbol"'>{{ item.marginLvl }}</td>

              <td :class='item.exposure >= 0  ? "positive" : "negative"' class='rowData tableCol' v-if='paramType!=="flow" && !isLots'>{{ item.exposure | formatAmount }}</td>
              <td :class='item.numberOfLot >= 0  ? "positive" : "negative"'  class='rowData tableCol' v-if='paramType!=="flow" && isLots'>{{ item.numberOfLot | formatAmount }}</td>
              <td :class='item.profitAndLoss >= 0  ? "positive" : "negative"'  class='rowData tableCol' v-if='paramType!=="flow"'>{{ item.profitAndLoss | formatAmount }}</td>
              <td class='rowData tableCol' v-if='paramType!=="flow"'>{{ item.vwap | formatRate(6) }}</td>
              <td :class='item.volume >= 0  ? "positive" : "negative"'  class='rowData tableCol' v-if='paramType!=="flow"'>{{ item.volume | formatAmount }}</td>
              <td class='rowData' v-if='paramType!=="flow"'>{{ item.ticketCount | formatCount }}</td>
              <td :class='item.markupAmount >= 0  ? "positive" : "negative"'  class='rowData tableCol' v-if='paramType!=="flow" && includeMarkupsVal'>{{ item.markupAmount | formatAmount }}</td>
              <td :class='item.markupPoints >= 0  ? "positive" : "negative"'  class='rowData tableCol' v-if='paramType!=="flow" && includeMarkupsVal'>{{ item.markupPoints | formatAmount }}</td>

              <td :class='item.financingLong >= 0  ? "positive" : "negative"'  class='rowData tableCol' v-if='paramType ==="flow"'>{{ item.financingLong | formatAmount }}</td>
              <td :class='item.financingShort >= 0  ? "positive" : "negative"'  class='rowData tableCol' v-if='paramType ==="flow"'>{{ item.financingShort | formatAmount }}</td>
              <td :class='item.rollOver >= 0  ? "positive" : "negative"'  class='rowData tableCol' v-if='paramType==="account"'>{{ item.rollOver | formatAmount }}</td>
              <td :class='item.commission >= 0  ? "positive" : "negative"'  class='rowData tableCol' v-if='paramType ==="account" || paramType ==="flow"'>{{ item.commission | formatAmount }}</td>
            </tr>
          </table>

        </lu-item>
    </lu-scroll-area>
  </lu-vbox>
</template>

<script>
import utils from '@/utils/formatNumber'
import { LuVbox, LuHbox, LuItem, LuScrollArea } from'lusis-ui'
import { mapGetters, mapState } from 'vuex'
import PageTitle from '@/components/PageTitle'
import { timestamp } from '@/utils'
import monitoringMixin from './mixins'

export default {
  name: 'DetailView',
  props: [ 'detailParams', 'data', 'detailPanelId' ],
  mixins: [ monitoringMixin ],
  data () {
    return {
      lotsMios: 'mios',
      value: []
    }
  },
  components: { PageTitle, LuVbox, LuHbox, LuItem, LuScrollArea },
  mounted() {
    this.initLotsMios()
  },
  created () {
    // this.subscribeDetail()
  },
  beforeDestroy () {
    this.unsubscribeDetail()
  },
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value || 0, 2, 3)
    },
    formatCount: function (value) {
      return utils.formatNumber(value || 0, 0)
    },
    formatPercent: function (value) {
      return (value || 0) + ' %'
    },
    formatRate: function (value, prec) {
      value = value || 0
      let idx = ('' + value).indexOf('.')
      if (idx !== -1) prec = value.length - idx - 1
      return utils.formatNumber(value, prec)
    }
  },
  computed: {
    ...mapGetters([ 'theme', 'bookList' ]),
    ...mapState({ includeMarkupsVal: state => state.settingsMonitor.settingParams.includeMarkups }),
    paramType () {
      return this.detailParams.type
    },
    isLots () {
      return this.lotsMios === 'lots'
    },
    title () {
      let title = this.detailParams.title
      let value = this.detailParams.value
      if (this.detailParams.type === 'account') {
        title = 'Client'
        if (this.data && this.data.extraInfo) {
          if (this.data.extraInfo.accountName) {
            value = this.data.extraInfo.accountName
          }
        }
      }
      return title + ' : ' + value
    },
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    },
    showBookFilter () {
      return this.detailParams.type === 'account'? false : true
    },
    tableHeaders () {
      let headers = []
      if (this.paramType !== 'account') headers.push('Env')
      headers.push('Book')
      if (this.paramType === 'symbol') headers.push('Client', 'Account')
      else if (this.paramType === 'currency') headers.push('Client', 'Account', 'Instrument')
      else if (this.paramType === 'account') headers.push('Instrument')
      else if (this.paramType === 'flow') headers.push('Client', 'Account', 'Swap Long', 'Swap Short', 'Commission')
      if (this.paramType === 'symbol') headers.push('Agent')
      if (this.paramType === 'symbol') headers.push('Margin Level')
      if (this.paramType !== 'flow' && !this.isLots) headers.push('Exposure')
      if (this.paramType !== 'flow' && this.isLots) headers.push('Lots')
      if (this.paramType !== 'flow') headers.push('P&L', 'VWAP', 'Volume', 'Ticket')
      if (this.paramType !== 'flow' && this.includeMarkupsVal) headers.push('Mkp Amt', 'Mkp Pts')
      if (this.paramType === 'account') headers.push('Swap', 'Commission')
      return headers
    },
    //!!! used for export, needs to be updated when template is changed
    tableFields () {
      let fields = []
      if (this.paramType !== 'account') fields.push('brokerName')
      fields.push('bookName')
      if (this.paramType === 'symbol') fields.push('dosName', 'accountNumber')
      else if (this.paramType === 'currency') fields.push('dosName', 'accountNumber', 'instrumentName')
      else if (this.paramType === 'account') fields.push('instrumentName')
      else if (this.paramType === 'flow') fields.push('dosName', 'accountNumber', 'financingLong', 'financingShort', 'commission')
      if (this.paramType === 'symbol') fields.push('agent')
      if (this.paramType === 'symbol') fields.push('marginLvl')
      if (this.paramType !== 'flow' && !this.isLots) fields.push('exposure')
      if (this.paramType !== 'flow' && this.isLots) fields.push('numberOfLot')
      if (this.paramType !== 'flow') fields.push('profitAndLoss', 'vwap', 'volume', 'ticketCount')
      if (this.paramType !== 'flow' && this.includeMarkupsVal) fields.push('markupAmount', 'markupPoints')
      if (this.paramType === 'account') fields.push('rollOver', 'commission')
      return fields
    }
  },
  methods: {
    subscribeDetail() {

    },
    unsubscribeDetail() {

    },
    setDetail(row) {
      if (this.paramType === 'symbol') {
        this.getDetail("account", row.brokerName, row.accountNumber, row.dosName)
      }
      else {
        this.getDetail("symbol", row.brokerName, row.accountNumber, row.instrumentName)
      }
    },
    detailToggleClose () {
      this.$emit('togglePageTitle')
    },
    getDetail (type, brokerName, accountNumber, val) {
      let params = [
        {'paramName': type, 'paramValue': val}
      ]
      let title = ''
      if (type === 'symbol') {
        params.push({'paramName': 'origin', 'paramValue': 'TopLong'})
        title = 'Top Long'
      }
      else if (type === 'currency') {
        params.push({'paramName': 'origin', 'paramValue': 'TopWinning'})
        title = 'Top Winning'
      }
      else if (type === 'account') {
        params.push({'paramName': 'origin', 'paramValue': 'TopWinningClient'})
        params.push({'paramName': 'platform', 'paramValue': brokerName})
        params.push({'paramName': 'accountNumber', 'paramValue': accountNumber})
        title = 'Client'
      }
      // this.$store.dispatch('settingsMonitor/changeDetailParams', {title: title, type: type, value: val, params: params, show: true})
      this.$emit('getDetail', {title: title, type: type, value: val, params: params, show: true})
    },
    detailChangeBookFilter() {
      this.$emit('detailChangeBookFilter')
    },
    formatToolTip: function (value) {
      if (this.getBookFilterIsValid(value))
        return value[0] + ' / ' + value[1]
      else
        return ''
    },
    disableToolTip: function (value) {
      return !this.getBookFilterIsValid(value)
    },
    getBookFilterIsValid(value) {
      return !(value[0]===undefined || value[0]===null || value[1]===undefined || value[1]===null ||(value[0]==="" && value[1]===""))
    },
    filterMethod(node, keyword) {
      const { text } = node;
      return text.toLowerCase().includes(keyword.toLowerCase());
    },
    setBookFilterValue(value) {
      this.value = value
    },
    initLotsMios () {
      if (this.detailParams && this.detailParams.lotsMios) {
        this.lotsMios = this.detailParams.lotsMios
      }
    },
    onexportexcel: function () {
      this.$emit('exportexcel')
    },
    handleDownload (dataList, sheetOnly) {
      return import('@/vendor/Export2Excel').then(excel => {
        const tHeader = this.tableHeaders
        const filterVal = this.tableFields
        let filePrefix = this.title ? this.title : 'detail'

        const list = dataList
        const data = this.formatJson(filterVal, list)

        if (sheetOnly) {
          return {
            data: data,
            header: tHeader,
            sheetName: filePrefix.replace(/[^a-zA-Z0-9]/g, ' ')
          }
        }

        filePrefix = filePrefix.replace(/[^a-zA-Z0-9]/g, '_')
        let filename = filePrefix + '_' +  timestamp()
        excel.export_json_to_excel_lusis({
          header: tHeader,
          data: data,
          filename: filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType,
          sheetName: filePrefix
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.tableCol {
  padding: 10px;
}

.detailView {
  padding: 10px;
}

.title {
  font-size: 1.2em;
}
.card-container {
  .titleInfo {
    border-radius: 5px;
    margin: 0 10px 10px 10px;

    .item {
      margin-left: 5px;
      padding: 10px;

      .title {
        font-size: 1em;
      }

      .value {
        font-size: 1.2em;
      }
    }
  }
}

.app-container .el-input {
  .el-input__inner {
    width: 100% !important;
    //width: 120px;
    //max-width: 50%;
  }
}
</style>